import React from "react";
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Alert,
} from "@mui/material";
import { Z } from "../../../theme/zIndex";
import AppDialog from "../../shared/components/AppDialog";
import ApartmentIcon from "@mui/icons-material/Apartment";
import { formatCurrency } from "../../shared/utils/formatters";

interface PendingDepartmentChange {
  newDepartment: string;
  currentPrice: number;
  newPrice: number;
  pricePerNight: number;
  newPricePerNight: number;
  newPriceSpecial?: number;
  newPricePerNightSpecial?: number;
}

interface DepartmentChangeModalProps {
  open: boolean;
  onClose: () => void;
  pendingDepartmentChange: PendingDepartmentChange | null;
  formData: {
    late_checkout: boolean;
  };
  onMantenerPrecioEspecial: () => void;
  onUsarPrecioBase: () => void;
  onCancelar: () => void;
}

const DepartmentChangeModal: React.FC<DepartmentChangeModalProps> = ({
  open,
  onClose,
  pendingDepartmentChange,
  formData,
  onMantenerPrecioEspecial,
  onUsarPrecioBase,
  onCancelar,
}) => {
  return (
    <AppDialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{ zIndex: Z.modal + 100 }}
    >
      <DialogTitle sx={{ flexShrink: 0 }}>
        <Box display="flex" alignItems="center" gap={1}>
          <ApartmentIcon color="warning" />
          <Typography variant="h6">Cambio de departamento</Typography>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ minHeight: 0, overflowY: "auto", flex: 1 }}>
        <Alert severity="info" sx={{ mb: 2 }}>
          Elegí el precio para el cambio al departamento{" "}
          {pendingDepartmentChange?.newDepartment}. El cambio queda listo para
          guardar en la reserva.
        </Alert>

        <Box sx={{ mt: 2 }}>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            <strong>Opción 1: Mantener precio actual</strong>
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Precio total:{" "}
            <strong>
              {formatCurrency(pendingDepartmentChange?.currentPrice || 0)}
            </strong>
            {formData.late_checkout && " (incluye late check-out)"}
            <br />
            Precio por noche:{" "}
            <strong>
              {formatCurrency(pendingDepartmentChange?.pricePerNight || 0)}
            </strong>
          </Typography>

          <Typography variant="body2" color="text.secondary" gutterBottom>
            <strong>Opción 2: Usar precio base del nuevo departamento</strong>
          </Typography>
          <Typography variant="body1">
            Precio total:{" "}
            <strong>
              {formatCurrency(pendingDepartmentChange?.newPrice || 0)}
            </strong>
            {formData.late_checkout && " (incluye late check-out)"}
            <br />
            Precio por noche:{" "}
            <strong>
              {formatCurrency(pendingDepartmentChange?.newPricePerNight || 0)}
            </strong>
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ flexShrink: 0, borderTop: 1, borderColor: "divider", bgcolor: "background.paper" }}>
        <Button onClick={onCancelar} color="inherit">
          Cancelar
        </Button>
        <Button onClick={onUsarPrecioBase} color="primary" variant="outlined">
          Usar precio base y seguir
        </Button>
        <Button
          onClick={onMantenerPrecioEspecial}
          color="success"
          variant="contained"
        >
          Mantener precio y seguir
        </Button>
      </DialogActions>
    </AppDialog>
  );
};

export default DepartmentChangeModal;
